<template>
    <div class="error-view" :class="{ 'is-embedded': embedded }">
        <BaseNotification theme="error" hide-dismiss class="notice" :text="message" />
        <BaseButton theme="secondary" @click="emit('retry')">
            <i aria-hidden="true" class="bi bi-arrow-clockwise"></i>
            {{ t("common.tryAgain") }}
        </BaseButton>
        <BaseButton v-if="showContinue" theme="tertiary" @click="emit('continue')">{{ t("common.continueAnyway") }}</BaseButton>
    </div>
</template>

<script setup lang="ts">
import BaseButton from "~vue/components/BaseButton.vue";
import BaseNotification from "~vue/components/BaseNotification.vue";
import { computed } from "vue";
import { useI18n } from "vue-i18n";

const emit = defineEmits<{ retry: []; continue: [] }>();
const { embedded = false, showContinue = false } = defineProps<{ embedded?: boolean; showContinue?: boolean }>();
const { t } = useI18n();
const message = computed(() => `${t("onboarding.calendarFirst.errorView.title")}. ${t("onboarding.calendarFirst.errorView.body")}`);
</script>

<style scoped>
@reference "../../../css/tailwind.css";

@layer components {
    .error-view {
        @apply mx-auto flex max-w-md flex-1 flex-col items-center justify-center gap-4 px-6 pb-10 text-center;
    }

    .notice {
        @apply w-full text-left;
    }
}
</style>
